import { combineReducers } from 'redux'
import auth from './auth'
import screen from './screen'
import data from './data'
import app from './app'
import fields from './fields'
import onboarding from './onboarding'
import modals from './modals'
import uploadData from "./uploadData";

export default combineReducers({
  app,
  auth,
  screen,
  data,
  fields,
  onboarding,
  modals,
  uploadData
})
